import React from 'react'

import { CommentsCommentFragment } from 'generated/resources/graphql'

import { ReactionsReactionValues } from 'modules/core/components/Reactions/Reaction'

import FirstAndLastComments from './FirstAndLastComments'
import FullListWithScroll from './FullListWithScroll'

export type CommentsListType = 'firstAndLast' | 'fullListWithScroll'
interface Props {
  type: CommentsListType
  previousComments: CommentsCommentFragment[]
  comments: CommentsCommentFragment[]
  totalCount: number
  onShowMore?: () => void
  onAddReaction?: (
    variables: ReactionsReactionValues,
    parentResourceId: number
  ) => Promise<{ id: number } | undefined>
  onDeleteReaction?: (
    id: number,
    parentResourceId: number,
    resourceId: number,
    textCode: string
  ) => Promise<{ success: boolean } | undefined>
}

const CommentsList = ({
  type,
  previousComments,
  comments,
  totalCount,
  onShowMore,
  onAddReaction,
  onDeleteReaction,
}: Props) => {
  if (type === 'firstAndLast') {
    return (
      <FirstAndLastComments
        previousComments={previousComments}
        comments={comments}
        totalCount={totalCount}
        onShowMore={onShowMore}
        onAddReaction={onAddReaction}
        onDeleteReaction={onDeleteReaction}
      />
    )
  }

  return (
    <FullListWithScroll
      comments={comments}
      onAddReaction={onAddReaction}
      onDeleteReaction={onDeleteReaction}
    />
  )
}

export default CommentsList
